<template>
  <div id="nav" :class="isMobile ? 'mobile-nav' : 'sidebar-nav'" style="z-index: 200;">
    <nav :class="isMobile ? 'navbar navbar-expand-lg navbar-dark bg-dark mobile-navbar' : 'sidebar bg-dark text-white'">
      <div style="padding-top: 60px !important;" class="d-flex flex-column align-items-center p-3" v-if="!isMobile">

        <button class="btn btn-secondary mb-3" @click.prevent="mtdnovo()">+</button>
        <i class="bi bi-house-fill mb-3" id="btdash" @click.prevent="mtddash()" style="font-size: 24px; cursor: pointer;"></i>
        <i class="bi bi-kanban-fill mb-3" @click.prevent="mtdmenu()" style="font-size: 24px; cursor: pointer;"></i>

        <i class="bi bi-pie-chart-fill mb-3" @click.prevent="mtdrelatorios()" style="font-size: 24px; cursor: pointer;"></i>
        <i class="bi bi-person-circle" @click.prevent="mtdperfil()" style="font-size: 24px; cursor: pointer;"></i>
      </div>

      <!-- Versão mobile original -->
      <div class="d-flex justify-content-around w-100 align-items-center" v-else>
        <i class="bi bi-house-fill" id="btdash" @click.prevent="mtddash()" style="font-size: 20px;"></i>
        <i class="bi bi-kanban-fill" @click.prevent="mtdmenu()" style="font-size: 20px;"></i>
        <button class="btn btn-secondary" @click.prevent="mtdnovo()">+</button>
        <i class="bi bi-pie-chart-fill" @click.prevent="mtdrelatorios()" style="font-size: 20px;"></i>
        <i class="bi bi-person-circle" @click.prevent="mtdperfil()" style="font-size: 20px;"></i>
      </div>
    </nav>
    <modal id="modalprest" :adaptive="true" name="modaltipo" :width="300" :height="200" >
      <div class="container py-5">
        <div class="row">
          <div class="col-12 mt-3">
            <div class="card border-primary bg-dark text-aquamarine" @click.prevent="mtdlancamentorapido('receita')">
              <div class="card-body text-center">
                <h4 class="card-title">
                  <i class="bi bi-box-arrow-in-up-right" style="font-size: 20px"></i> Receita
                </h4>
              </div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <div class="card border-secondary bg-dark text-light" @click.prevent="mtdlancamentorapido('despesa')">
              <div class="card-body text-center">
                <h4 class="card-title">
                  <i class="bi bi-box-arrow-down-right" style="font-size: 20px"></i> Despesa
                </h4>
              </div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <div class="card border-secondary bg-dark text-light" @click.prevent="mtdlancamentorapido('meta')">
              <div class="card-body text-center">
                <h4 class="card-title">
                  <i class="bi bi-bullseye" style="font-size: 20px"></i> Meta
                </h4>
              </div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <div class="card border-secondary bg-dark text-green" @click.prevent="mtdlancamentorapido('transf')">
              <div class="card-body text-center">
                <h4 class="card-title">
                  <i class="bi bi-arrow-left-right" style="font-size: 20px"></i> Tranferência
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <modal id="modallancamento" @before-close="mtdlimpadados()" :adaptive="true" name="modallancamento" :height="600">
      <div class="container py-4 bg-light" style="overflow: auto;">
        <div class="row">
          <div class="col-12" v-show="meta">
            <label class="lblselect2">Objetivo da meta:</label>
            <select id="cbmeta" v-model="vidmeta" class="form-control">
            </select>
          </div>

          <div class="col-12" v-show="parseInt(vtipolanca) === 1 && !transf">
            <label class="lblselect2">Buscar receita pré-definida:</label>
            <select id="cbreceita" v-model="vidreceitadespesa" class="form-control">
            </select>
          </div>

          <div class="col-12" v-show="parseInt(vtipolanca) === 2  && !transf">
            <label class="lblselect2">Buscar despesa pré-definida:</label>
            <select id="cbdespesa" v-model="vidreceitadespesa" class="form-control">
            </select>
          </div>

          <div class="col-12">
            <label for="eddtlanca">Dt. Lancto:</label>
            <date-picker class="form-control" v-model="vdtlanca" id="eddtlanca" format="DD/MM/YYYY"
              value-type="DD/MM/YYYY" />
          </div>

          <div class="col-12 mt-2" v-show="!transf" >
            <label for="cbqtdreg">Tipo:</label>
            <select name="cbqtdreg" id="cbqtdreg" v-model="vtipolanca" @change="mtdmudatipolanca" class="form-control"
              :style="parseInt(vtipolanca) === 1 ? 'background-color: darkgreen; color: white' : 'background-color: crimson; color: white'">
              <option value="1" style="background-color: darkgreen; color: white">Receita</option>
              <option value="2" style="background-color: crimson; color: white">Despesa</option>
            </select>
          </div>

          <div class="col-12 mt-2" v-show="transf" >
            <label class="lblselect2" v-show="transf">
               Conta de saida (saldo {{ mtdformatavalordecimal(saldocontaorigem, 'R$') }})
            </label>
            <select id="cbcontalorigem" v-model="vidcontaorigem" class="form-control">
            </select>
          </div>

          <div class="col-12 mt-2">
            <label class="lblselect2" v-show="!transf">
              *{{ parseInt(vtipolanca) === 2 ? 'Sai da' : 'Entra na' }} conta:
              (saldo {{ mtdformatavalordecimal(saldoconta, 'R$') }})
            </label>

            <label class="lblselect2" v-show="transf">
               Conta de entrada (saldo {{ mtdformatavalordecimal(saldoconta, 'R$') }})
            </label>
            <select id="cbcontal" v-model="vidconta" class="form-control">
            </select>
          </div>

          <div class="col-12 mt-2" v-show="parseInt(vtipolanca) === 1 && !transf">
            <label class="lblselect2">Categoria (Receita):</label>
            <select id="cbcategoriareceita" v-model="vidreceitadespesa" class="form-control">
            </select>
          </div>

          <div class="col-12 mt-2" v-show="parseInt(vtipolanca) === 2 && !transf">
            <label class="lblselect2">*Categoria (Despesa):</label>
            <select id="cbcategoriadespesa" v-model="vidcategoria" class="form-control">
            </select>
          </div>

          <div class="col-12 mt-2" v-show="!transf" >
           <label for="desclancto" class="form-label">Descrição</label>
            <input type="text" v-model="vdescricaolanto" id="desclancto" class="form-control" placeholder="Uma pequena descrição de seu lançamento"  >
          </div>

          <div class="col-12 mt-2">
            <label for="cbvalor">Valor:</label>
            <money id="cbvalor" v-model="valorlanca" v-bind="money" class="form-control text-end"></money>
          </div>

          <div class="col-12 mt-4">
            <button id="btgravar" @click.prevent="mtdregistrar()" class="btn btn-primary btn-block w-100">
              <i class="bi bi-check"></i> Registro
            </button>
          </div>
        </div>
      </div>
    </modal>
    <modal id="modalalteracaolancto" :adaptive="true" name="modalalteracaolancto" :width="300" :height="200" >
      <div class="container py-5">
        <div class="row">
          <div class="col-12 mt-3">
            <div class="card border-primary bg-dark text-aquamarine" @click.prevent="mtdlancamentorapido('receita')">
              <div class="card-body text-center">
                <h4 class="card-title">
                  <i class="bi bi-box-arrow-in-up-right" style="font-size: 20px"></i> Alterar 
                </h4>
              </div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <div class="card border-secondary bg-dark text-light" @click.prevent="mtdlancamentorapido('despesa')">
              <div class="card-body text-center">
                <h4 class="card-title">
                  <i class="bi bi-box-arrow-down-right" style="font-size: 20px"></i> Excluir
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
/* eslint-disable */
import Swal from 'sweetalert2'
import util from '../util.js'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';

export default {
  name: "footernav",
  props: {},
  components: {
    DatePicker
  },
  data: function () {
    return {
      vopcrudlancto    : 0, 
      vtipolanca       : 0,
      vidreceitadespesa: null,
      vidconta         : null,
      saldoconta       : 0,
      saldocontaorigem : 0,
      vidcategoria     : null,
      valorlanca       : 0,
      meta             : false,
      vidmeta          : null,
      vdtlanca         : this.mtdpegadataatual(),
      vdescricaolanto  : '',
      isMobile         : false,
      transf           : false,
      vidcontaorigem   : null,


      money: {
        decimal  : ',',
        thousands: '.',
        prefix   : '',//aqui colocar o cifrão se for necessário
        precision: 2,
        masked   : false
      },
      options: {
        format    : 'DD/MM/YYYY',
        useCurrent: false,
        locale    : 'pt-BR'
      },
    }
  },
  methods: {
    mtdigualarcampos(){
      let registro             = this.dadoslancto;

      console.log(registro);

      this.vid                 = registro.id;
      this.vdescricao          = registro.descricao;
      this.vvalor              = registro.valor;

      this.vidcategoria        = registro.idcategoria;
      this.vidconta            = registro.idconta;
      this.vrecorrente         = registro.recorrente
      this.vdiavencimento      = registro.diavencimento

      var defcateg  = new Option(registro.deccategoria, registro.idcategoria, true, true);
      $('#cbcategoria').append(defcateg).trigger('change');

      var defconta  = new Option(registro.descconta, registro.idconta, true, true);
      $('#cbconta').append(defconta).trigger('change');
    },
    alteralancto(){
      this.mtdigualarcampos();
      this.$modal.show("modalalteracaolancto");
      this.$store.commit('definelancto', {});
    },
    mtdlimpadados(){
      window.localStorage.removeItem("dadoslancto");
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    mtdverificalanctofuturo() {

      let datalanca = util.DataBRtoObJ(this.vdtlanca);
      let dataatual = new Date()

      datalanca.setHours(0, 0, 0, 0)
      dataatual.setHours(0, 0, 0, 0);

      if (datalanca > dataatual) {
        return true;
      } else {
        return false;
      }
    },
    mtdregistrar() {
      let vself = this;
      if(!this.vidcategoria && !this.transf){
        util.notif('error', 'Informação!', "Informe uma categoria!");
        return;
      }

      if(!this.vidconta){
        util.notif('error', 'Informação!', "Informe uma conta!");
        return;
      }

      if(!this.vidcontaorigem && this.transf){
        util.notif('error', 'Informação!', "Informe uma categoria!");
        return;
      }

      if(parseFloat(this.valorlanca)  === 0){
        util.notif('error', 'Informação!', "Informe um valor para o lançamento!");
        return;
      }
      if (vself.mtdverificalanctofuturo()) {
        Swal.fire({
          title: "Confirmação",
          text: 'O Registro é um lançamento futuro. Tem certeza que deseja lança-lo?',
          icon: "warning",
          customClass: {
            confirmButton: "conf btn btn-success",
            cancelButton: "btn btn-danger"
          },
          showCancelButton: true,
          confirmButtonColor: "black",
          cancelButtonText: "Não",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim"
        }).
          then((result) => {
            if (result.isConfirmed) {
              $('.conf').prop('disabled', true);
              vself.mtdregistrofuturo();
            } else {
              $('#btgravar').focus();
            }
          });
      } else {
        Swal.fire({
          title: "Confirmação",
          text: 'Deseja salvar o movimento?',
          icon: "warning",
          customClass: {
            confirmButton: "conf btn btn-success",
            cancelButton: "btn btn-danger"
          },
          showCancelButton: true,
          confirmButtonColor: "black",
          cancelButtonText: "Não",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim"
        }).
          then((result) => {
            if (result.isConfirmed) {
              $('.conf').prop('disabled', true);
              if(vself.transf){
                vself.mtdtranferencia();
              }else{
                vself.mtdregistro();
              }
            } else {
              $('#btgravar').focus();
            }
          });
      }
    },
    mtdregistrofuturo() {
      //agenda = true;
      let vself = this;
      let registro = {
        'valor'        : this.valorlanca,
        'idcategoria'  : this.vidcategoria,
        'tipo'         : this.vtipolanca,
        'idmeta'       : this.vidmeta === null ? 0 : this.vidmeta,
        'idreceitapre' : this.vidreceitadespesa === null ? 0 : this.vidreceitadespesa,
        'descricao'    : this.vdescricaolanto,
        'idconta'      : this.vidconta,
        'dtlancamento' : this.vdtlanca,
      };

      let parametros = [
        { parametro: 'op',        valor: 'rotinacrud' },
        { parametro: 'registro',  valor: JSON.stringify(registro) },
        { parametro: 'opcrud',    valor: this.vopcrudlancto },
        { parametro: 'idusuario', valor: localStorage.getItem('iduser') },
      ];
      let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/cadagendamento.php');
      retorno.then(function (response) {
        if ($.isNumeric(response.data)) {
          util.notif('success', 'Informação!', 'Registro processado com sucesso!');
          vself.mtdfechalancamento();
          util.atzdash();
        } else {
          let tpret = response.data.substring(0, 1);
          switch (tpret) {
            case 'I':
              util.notif('error', 'Informação!', response.data.substring(4));
              break;
            case 'E': default:
              util.notif('error', 'Informação!', response.data.substring(4));
              break;
          }
        }
      }).catch(function (response) {
       
      });
    },
    mtdtranferencia() {
      let vself = this;
      let registro = {
        'valor'        : this.valorlanca,
        'idconta'      : this.vidconta,
        'idcontaorigem': this.vidcontaorigem,
        'dtlancamento' : this.vdtlanca,
      };

      let parametros = [
        { parametro: 'op',        valor: 'transferencia' },
        { parametro: 'registro',  valor: JSON.stringify(registro) },
        { parametro: 'opcrud',    valor: this.vopcrudlancto },
        { parametro: 'idusuario', valor: localStorage.getItem('iduser') },
      ];
      let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/cadlancamento.php');
      retorno.then(function (response) {
        if ($.isNumeric(response.data)) {
          util.notif('success', 'Informação!', 'Registro processado com sucesso!');
          vself.mtdfechalancamento();
          util.atzdash();
        } else {
          let tpret = response.data.substring(0, 1);
          switch (tpret) {
            case 'I':
              util.notif('error', 'Informação!', response.data.substring(4));
              break;
            case 'E': default:
              util.notif('error', 'Informação!', response.data.substring(4));
              break;
          }
        }
      }).catch(function (response) {
       
      });
    },
    mtdregistro() {
      let vself = this;
      let registro = {
        'valor'       : this.valorlanca,
        'idcategoria' : this.vidcategoria,
        'tipo'        : this.vtipolanca,
        'descricao'   : this.vdescricaolanto,
        'idmeta'      : this.vidmeta === null ? 0 : this.vidmeta,
        'idreceitapre': this.vidreceitadespesa === null ? 0 : this.vidreceitadespesa,
        'idconta'     : this.vidconta,
        'dtlancamento': this.vdtlanca,
      };

      let parametros = [
        { parametro: 'op',        valor: 'rotinacrud' },
        { parametro: 'registro',  valor: JSON.stringify(registro) },
        { parametro: 'opcrud',    valor: this.vopcrudlancto },
        { parametro: 'idusuario', valor: localStorage.getItem('iduser') },
      ];
      let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/cadlancamento.php');
      retorno.then(function (response) {
        if ($.isNumeric(response.data)) {
          util.notif('success', 'Informação!', 'Registro processado com sucesso!');
          vself.mtdfechalancamento();
          util.atzdash();

        } else {
          let tpret = response.data.substring(0, 1);
          switch (tpret) {
            case 'I':
              util.notif('error', 'Informação!', response.data.substring(4));
              break;
            case 'E': default:
              util.notif('error', 'Informação!', response.data.substring(4));
              break;
          }
        }
      }).catch(function (response) {
        
      });
    },
    mtdpegadataatual() {
      const dataAtual = new Date();
      const dia = String(dataAtual.getDate()).padStart(2, '0'); // Dia com dois dígitos
      const mes = String(dataAtual.getMonth() + 1).padStart(2, '0'); // Mês com dois dígitos (lembrando que getMonth() retorna de 0 a 11)
      const ano = dataAtual.getFullYear();
      return `${dia}/${mes}/${ano}`;
    },
    mtdbuscardadosreceitas() {
      var vself = this;
      let filtro = ' and pl.id=' + this.vidreceitadespesa;
      let parametros = [
        { parametro: 'op', valor: 'listagem' },
        { parametro: 'idusuario', valor: localStorage.getItem('iduser') },
        { parametro: 'filtro', valor: filtro },
        { parametro: 'limit', valor: '99999' },
        { parametro: 'offset', valor: '0' },
      ];
      let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/cadreceitasdespesas.php');
      retorno.then(function (response) {
        vself.lstreceitasdespesas = response.data;
        vself.vidconta = parseInt(response.data[0].idconta)

        vself.vidcategoria = response.data[0].idcategoria;
        vself.valorlanca = response.data[0].valor;

        var defcateg = new Option(response.data[0].deccategoria, response.data[0].idcategoria, true, true);

        if (parseInt(vself.vtipolanca) === 1) {
          $('#cbcategoriareceita').append(defcateg).trigger('change');
        } else {
          $('#cbcategoriadespesa').append(defcateg).trigger('change');
        }
        var defconta = new Option(response.data[0].descconta, response.data[0].idconta, true, true);
        $('#cbcontal').append(defconta).trigger('change');

        const dataAtual = new Date();
        const dia = String(dataAtual.getDate()).padStart(2, '0'); // Dia com dois dígitos
        const mes = String(dataAtual.getMonth() + 1).padStart(2, '0'); // Mês com dois dígitos (lembrando que getMonth() retorna de 0 a 11)
        const ano = dataAtual.getFullYear();

        const dataFormatadaBrasil = `${dia}/${mes}/${ano}`;

        vself.vdtlanca = dataFormatadaBrasil;
      }).catch(function (response) {

      });
    },
    mtdformatavalordecimal(valor, digitos) {
      return util.formatarvalor(valor, digitos);
    },
    mtdmenu() {
      $('#dash').hide();
      $('#relatorios').hide();
      $('#perfil').hide();
      $('#menu').show();
    },
    mtddash() {
      $('#relatorios').hide();
      $('#menu').hide();
      $('#perfil').hide();
      $('#dash').show();
      util.resetZoom();
    },
    mtdrelatorios() {
      $('#menu').hide();
      $('#dash').hide();
      $('#perfil').hide();
      $('#relatorios').show();
    },
    mtdperfil() {
      $('#menu').hide();
      $('#relatorios').hide();
      $('#dash').hide();
      $('#perfil').show();
    },
    mtdfechalancamento() {
      let vself = this;
      vself.transf            = false;
      vself.vopcrudlancto     = 0;
      vself.vtipolanca        = 0,
      vself.vidreceitadespesa = null;
      vself.vidconta          = null;
      vself.vidcontaorigem    = null;
      vself.saldoconta        = 0;
      vself.saldocontaorigem  = 0;
      vself.vidcategoria      = null;
      vself.vidmeta           = null;
      vself.meta              = false;
      vself.valorlanca        = 0;
      vself.vdescricaolanto   = '';
      vself.vdtlanca          = this.mtdpegadataatual();

      $("#cbcategoriadespesa").val(null).trigger('change');
      $("#cbcategoriareceita").val(null).trigger('change');
      $("#cbcontal").val(null).trigger('change');
      $("#cbcontalorigem").val(null).trigger('change');
      $("#cbmeta").val(null).trigger('change');


      this.$modal.hide("modallancamento");
    },
    mtdnovo() {
      this.$modal.show("modaltipo");
    },
    mtdlancamentorapido(op) {
      let vself = this;

      this.mtdfechalancamento();
      this.vopcrudlancto = 1;
      switch (op) {
        case 'receita':
          this.vtipolanca = 1;
          this.$modal.show("modallancamento");
          break;
        case 'despesa':
          this.vtipolanca = 2;
          this.$modal.show("modallancamento");
          break;
        case 'meta':
          this.meta = true;
          this.vtipolanca = 2;
          this.$modal.show("modallancamento");
          break;
        case 'transf':
          this.transf = true;
          this.$modal.show("modallancamento");
          break;
          
      }

      setTimeout(() => {
        $("#cbdespesa").select2({
          id: function (e) { return e.codfil },
          ajax: {
            url: util.servidor + '/controller/select2sql.php',
            dataType: 'json',
            delay: 250,
            data: function (params) {
              return {
                q: params.term,
                sqlini: 'select pl.id, pl.descricao from tbperfislancamento pl ' +
                        'left join tbcategorias c ON c.id = pl.idcategoria ',
                sqlfim: 'where upper(pl.descricao) like upper("%@@%") and c.tipo = 0 and c.idusuario =' + localStorage.getItem('iduser'),
                cpid: 'id',
                cpdesc: 'descricao'
              };
            },
            processResults: function (data) {
              return {
                results: data
              };
            },
            cache: true
          },
          minimumInputLength: 0,
          theme: 'bootstrap',
          language: "pt-BR",
          templateResult: util.formatResult,
          templateSelection: util.formatSelection
        }).change(function () {
          vself.vidreceitadespesa = $("#cbdespesa").val();
          if (vself.vidreceitadespesa !== null) {
            vself.mtdbuscardadosreceitas();
          }
        });
        $("#cbreceita").select2({
          id: function (e) { return e.codfil },
          ajax: {
            url: util.servidor + '/controller/select2sql.php',
            dataType: 'json',
            delay: 250,
            data: function (params) {
              return {
                q: params.term,
                sqlini: 'select pl.id, pl.descricao from tbperfislancamento pl ' +
                        'left join tbcategorias c ON c.id = pl.idcategoria ',
                sqlfim: 'where upper(pl.descricao) like upper("%@@%") and c.tipo = 1 and c.idusuario =' + localStorage.getItem('iduser'),
                cpid: 'id',
                cpdesc: 'descricao'
              };
            },
            processResults: function (data) {
              return {
                results: data
              };
            },
            cache: true
          },
          minimumInputLength: 0,
          theme: 'bootstrap',
          language: "pt-BR",
          templateResult: util.formatResult,
          templateSelection: util.formatSelection
        }).change(function () {
          vself.vidreceitadespesa = $("#cbreceita").val();

          if (vself.vidreceitadespesa !== null) {
            vself.mtdbuscardadosreceitas();
          }
        });
        $("#cbcontal").select2({
          id: function (e) { return e.codfil },
          ajax: {
            url: util.servidor + '/controller/select2sql.php',
            dataType: 'json',
            delay: 250,
            data: function (params) {
              return {
                q: params.term,
                sqlini: 'select id, descricao from tbcontas ',
                sqlfim: 'where upper(descricao) like upper("%@@%") and idusuario =' + localStorage.getItem('iduser'),
                cpid: 'id',
                cpdesc: 'descricao'
              };
            },
            processResults: function (data) {
              return {
                results: data
              };
            },
            cache: true
          },
          minimumInputLength: 0,
          theme: 'bootstrap',
          language: "pt-BR",
          templateResult: util.formatResult,
          templateSelection: util.formatSelection
        }).change(function () {
          vself.vidconta = $("#cbcontal").val();

          if (vself.vidconta) {
            let filtro = ' and c.id=' + vself.vidconta;
            let parametros = [
              { parametro: 'op', valor: 'listagem' },
              { parametro: 'idusuario', valor: localStorage.getItem('iduser') },
              { parametro: 'filtro', valor: filtro },
              { parametro: 'limit', valor: '99999' },
              { parametro: 'offset', valor: '0' },
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/cadcofrescontas.php');
            retorno.then(function (response) {
              vself.saldoconta = parseFloat(response.data[0].saldo);
            }).catch(function (response) {

            });
          }

        });
         $("#cbcontalorigem").select2({
          id: function (e) { return e.codfil },
          ajax: {
            url: util.servidor + '/controller/select2sql.php',
            dataType: 'json',
            delay: 250,
            data: function (params) {
              return {
                q: params.term,
                sqlini: 'select id, descricao from tbcontas ',
                sqlfim: 'where upper(descricao) like upper("%@@%") and idusuario =' + localStorage.getItem('iduser'),
                cpid: 'id',
                cpdesc: 'descricao'
              };
            },
            processResults: function (data) {
              return {
                results: data
              };
            },
            cache: true
          },
          minimumInputLength: 0,
          theme: 'bootstrap',
          language: "pt-BR",
          templateResult: util.formatResult,
          templateSelection: util.formatSelection
        }).change(function () {
          vself.vidcontaorigem = $("#cbcontalorigem").val();

          if (vself.vidcontaorigem) {
            let filtro = ' and c.id=' + vself.vidcontaorigem;
            let parametros = [
              { parametro: 'op', valor: 'listagem' },
              { parametro: 'idusuario', valor: localStorage.getItem('iduser') },
              { parametro: 'filtro', valor: filtro },
              { parametro: 'limit', valor: '99999' },
              { parametro: 'offset', valor: '0' },
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/cadcofrescontas.php');
            retorno.then(function (response) {
              vself.saldocontaorigem = parseFloat(response.data[0].saldo);
            }).catch(function (response) {

            });
          }

        });
        $("#cbcategoriareceita").select2({
          id: function (e) { return e.codfil },
          ajax: {
            url: util.servidor + '/controller/select2sql.php',
            dataType: 'json',
            delay: 250,
            data: function (params) {
              return {
                q: params.term,
                sqlini: 'select id, nome from tbcategorias ',
                sqlfim: 'where upper(nome) like upper("%@@%") and tipo = 1 and idusuario =' + localStorage.getItem('iduser'),
                cpid: 'id',
                cpdesc: 'nome'
              };
            },
            processResults: function (data) {
              return {
                results: data
              };
            },
            cache: true
          },
          minimumInputLength: 0,
          theme: 'bootstrap',
          language: "pt-BR",
          templateResult: util.formatResult,
          templateSelection: util.formatSelection
        }).change(function () {
          vself.vidcategoria = $("#cbcategoriareceita").val();
        });
        $("#cbcategoriadespesa").select2({
          id: function (e) { return e.codfil },
          ajax: {
            url: util.servidor + '/controller/select2sql.php',
            dataType: 'json',
            delay: 250,
            data: function (params) {
              return {
                q: params.term,
                sqlini: 'select id, nome from tbcategorias ',
                sqlfim: 'where upper(nome) like upper("%@@%") and tipo = 0 and idusuario =' + localStorage.getItem('iduser'),
                cpid: 'id',
                cpdesc: 'nome'
              };
            },
            processResults: function (data) {
              return {
                results: data
              };
            },
            cache: true
          },
          minimumInputLength: 0,
          theme: 'bootstrap',
          language: "pt-BR",
          templateResult: util.formatResult,
          templateSelection: util.formatSelection
        }).change(function () {
          vself.vidcategoria = $("#cbcategoriadespesa").val();
        });
        $("#cbmeta").select2({
          id: function (e) { return e.codfil },
          ajax: {
            url: util.servidor + '/controller/select2sql.php',
            dataType: 'json',
            delay: 250,
            data: function (params) {
              return {
                q: params.term,
                sqlini: 'select id, descricao from tbmetas ',
                sqlfim: 'where upper(descricao) like upper("%@@%")  and idusuario =' + localStorage.getItem('iduser'),
                cpid: 'id',
                cpdesc: 'descricao'
              };
            },
            processResults: function (data) {
              return {
                results: data
              };
            },
            cache: true
          },
          minimumInputLength: 0,
          theme: 'bootstrap',
          language: "pt-BR",
          templateResult: util.formatResult,
          templateSelection: util.formatSelection
        }).change(function () {
          vself.vidmeta = $("#cbmeta").val();
        });
      }, 700);
    },
    mtdmudatipolanca() {

    }
  },
  mounted() {
    this.isMobile = window.innerWidth <= 768;
    window.addEventListener('resize', this.checkMobile);

    // setInterval(() => {
    //   const dadoslancto = localStorage.getItem('dadoslancto');
    //     if (dadoslancto === null) {
    //       this.dadoslancto = [];
    //     } else {
    //       this.dadoslancto = JSON.parse(dadoslancto) 
    //       localStorage.removeItem("dadoslancto"); 
    //     }
      
    // }, 200);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  watch: {
    isMobile(val) {
      if (val) {
        document.getElementById("conteudo").style.paddingLeft = "0px";
      } else {
        document.getElementById("conteudo").style.paddingLeft = "60px";
      }
    },
    dadoslancto(val){
      if(val.id){
        this.alteralancto();
      }
    }
 
  },
  computed: {
    dadoslancto(){
       return this.$store.state.dadoslancto;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
/* #nav {
  position: fixed;
  width: 100%;
  bottom: 0;
}



.mx-input {
  border: none !important;
  background-color: transparent !important;
}*/

.vm--modal {
  background-color: transparent !important;
  overflow: auto;
  box-shadow: none !important;
  height: auto !important;
}
.sidebar-nav {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 60px;
  margin-left: -60px;

  z-index: 200;
  background-color: #343a40;
}

.sidebar {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mobile-nav {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 200;
}

.mobile-navbar {
  display: flex;
  justify-content: space-around;
  padding-left: 20px;
  padding-right: 20px;
}
#cbqtdreg{
    padding-bottom: 4px;
    padding-top: 2px;
}
#eddtlanca{
  padding: 0;
}
#cbvalor{
  padding: 8px;
}
#modalprest .vm--modal{
   top: 90px !important;
}
</style>
